import { Component, OnDestroy, OnInit } from '@angular/core';
import { JhiAlertService } from 'ng-jhipster';

@Component({
    selector: 'jhi-alert',
    template: `
        <ng-container *ngFor="let alert of alerts">
            <div class="alert alert-{{alert.type}} alert-dismissible"
            [ngClass]="{'fixed-position fixed-bottom pb-3': alert.position === 'fixed'}" role="status">
                <button type="button" class="close" aria-label="Fermer" (click)="alert.close(alerts)">
                    <span aria-hidden="true">&times;</span>
                </button>
                <span [innerHTML]="alert.msg"></span>
            </div>
        </ng-container>
    `
})
export class JhiAlertComponent implements OnInit, OnDestroy {
    alerts: any[];

    constructor(private alertService: JhiAlertService) {}

    ngOnInit() {
        this.alerts = this.alertService.get();
    }

    ngOnDestroy() {
        this.alerts = [];
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/alert/alert.component.ts